import ContentArchive from './Main'

const route = {
  path: '/archive/:cateId/:id',
  name: 'archive-content',
  component: ContentArchive
}

export default route
